import axios from "axios";
import { TTP_API_URL } from "../config";

export const getBonusTypes = ({ token }) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/types`;
  const params = { access_token: token };

  return axios.get(requestUrl, {
    params,
  });
};

export const saveBonusTypes = ({ token, items }) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/types`;
  const formData = new FormData();

  formData.append('access_token', token);
  formData.append('items', JSON.stringify(items));

  return axios.post(requestUrl, formData);
};

export const getCollaboratorProcessingTime = ({
  token,
  organizationId,
  collaboratorId,
  startDate,
  endDate,
  categories,
  zoneId = null,
  excludedClients = []
}) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/processing-time`;
  const params = {
    access_token: token,
    organizationId,
    collaboratorId,
    startDate,
    endDate,
    categories,
    excludedClients
  };
  if (zoneId) {
    params.zoneId = zoneId;
  }
  return axios.get(requestUrl, { params });
};

export const getCollaboratorRatios = ({
  token,
  organizationId,
  collaboratorId,
  startDate,
  endDate
}) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/ratios`;
  const params = {
    access_token: token,
    organizationId,
    collaboratorId,
    startDate,
    endDate
  };
  return axios.get(requestUrl, { params });
}

export const getCollaboratorFoldersQuality = ({
  token,
  organizationId,
  collaboratorId,
  startDate,
  endDate
}) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/folders-quality-data`;
  const params = {
    access_token: token,
    organizationId,
    collaboratorId,
    startDate,
    endDate
  };
  return axios.get(requestUrl, { params });
}

export const getCollaboratorDocsProcessingData = ({
  token,
  organizationId,
  collaboratorId,
  startDate,
  endDate,
  excludedClients,
  docStatus
}) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/docs-processing-data`;
  const params = {
    access_token: token,
    organizationId,
    collaboratorId,
    startDate,
    endDate,
    excludedClients,
    docStatus
  };
  return axios.get(requestUrl, { params });
}

export const getCollaboratorNFHoursData = ({
  token,
  organizationId,
  collaboratorId,
  period
}) => {
  const requestUrl = `${TTP_API_URL}/team/oam-bonus/nf-hours-data`;
  const params = {
    access_token: token,
    organizationId,
    collaboratorId,
    period
  };
  return axios.get(requestUrl, { params });
}
